import { LucideIconData } from '@lucide/angular';

export const MicrosoftLogo: LucideIconData = {
    name: 'MicrosoftLogo',
    node: [
        [
            'rect',
            {
                x: '1',
                y: '1',
                width: '9',
                height: '9',
                fill: 'currentColor',
                stroke: 'none',
                key: '1ldfqx',
            },
        ],
        [
            'rect',
            {
                x: '1',
                y: '11',
                width: '9',
                height: '9',
                fill: 'currentColor',
                stroke: 'none',
                key: '1y8qzk',
            },
        ],
        [
            'rect',
            {
                x: '11',
                y: '1',
                width: '9',
                height: '9',
                fill: 'currentColor',
                stroke: 'none',
                key: 'g8n64s',
            },
        ],
        [
            'rect',
            {
                x: '11',
                y: '11',
                width: '9',
                height: '9',
                fill: 'currentColor',
                key: '168sgn',
                stroke: 'none',
            },
        ],
    ],
};
